module.exports = __webpack_public_path__ + "img/fullscreen_exit_img.846d166a.png";